import styled from 'styled-components';

export const Container = styled.div<{ $fixed?: boolean }>`
  &:hover {
    cursor: ${({ $fixed }) => ($fixed ? '' : 'grab')};
  }
`;
